import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { UpdateChannelRequestFilterSensitiveLog, } from "../models/models_0";
import { de_UpdateChannelCommand, se_UpdateChannelCommand } from "../protocols/Aws_restJson1";
export { $Command };
export class UpdateChannelCommand extends $Command
    .classBuilder()
    .ep({
    ...commonParams,
})
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
        getEndpointPlugin(config, Command.getEndpointParameterInstructions()),
    ];
})
    .s("ChimeMessagingService", "UpdateChannel", {})
    .n("ChimeSDKMessagingClient", "UpdateChannelCommand")
    .f(UpdateChannelRequestFilterSensitiveLog, void 0)
    .ser(se_UpdateChannelCommand)
    .de(de_UpdateChannelCommand)
    .build() {
}
